import { render, staticRenderFns } from "./WorkGroupSelect.vue?vue&type=template&id=4c70ad4d&"
import script from "./WorkGroupSelect.vue?vue&type=script&lang=js&"
export * from "./WorkGroupSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports